import Home from './home'
import CollectionRecord from './collectionRecord'
import LandingPage from './landingpage'
export default {
  Home,
  CollectionRecord,
  LandingPage
}
